import React from "react"

type LocalizedText = { en?: string; nl?: string } | string | undefined

export type MissiesBannerData = {
  eyebrow?: LocalizedText
  title?: LocalizedText
  subtitle?: LocalizedText
  media?: string
  ctaButton?: LocalizedText
  ctaLink?: string
  secondaryText?: LocalizedText
  secondaryLink?: string
  bridgeText?: LocalizedText
}

const L = (val: LocalizedText, languageCode: string, fallback = ""): string => {
  if (!val) return fallback
  if (typeof val === "string") return val
  return (val as any)[languageCode] || val.en || fallback
}

type Props = {
  data?: MissiesBannerData
  languageCode: string
}

const MissiesBanner: React.FC<Props> = ({ data, languageCode }) => {
  if (!data) return null

  const eyebrow = L(data.eyebrow, languageCode)
  const title = L(data.title, languageCode, "Play Techtok Missions. Now.")
  const subtitle = L(data.subtitle, languageCode)
  const ctaLabel = L(data.ctaButton, languageCode, "Play Now")
  const secondaryText = L(data.secondaryText, languageCode)
  const bridgeText = L(data.bridgeText, languageCode)
  const media = data.media || ""
  const isVideo = /\.(mp4|webm|mov)$/i.test(media)

  return (
    <section className="missies-banner">
      <div className="missies-banner-inner">
        <div className="missies-banner-copy">
          {eyebrow && <span className="missies-banner-eyebrow">{eyebrow}</span>}
          <h1 className="missies-banner-title">{title}</h1>
          {subtitle && <p className="missies-banner-subtitle">{subtitle}</p>}

          <div className="missies-banner-actions">
            <a className="missies-banner-cta" href={data.ctaLink || "/games/playquest/"}>
              {ctaLabel}
            </a>
            {secondaryText && data.secondaryLink && (
              <a className="missies-banner-secondary" href={data.secondaryLink}>
                {secondaryText} →
              </a>
            )}
          </div>

          {bridgeText && <p className="missies-banner-bridge">{bridgeText}</p>}
        </div>

        {media && (
          <div className="missies-banner-media">
            {isVideo ? (
              <video autoPlay muted loop playsInline src={media} />
            ) : (
              <img src={media} alt="Techtok Missies" />
            )}
          </div>
        )}
      </div>
    </section>
  )
}

export default MissiesBanner
